/*
	Customised and improved version of FlexNav.js 1.3.3

	Created by Jason Weaver http://jasonweaver.name
	Released under http://unlicense.org/

//
*/


(function () {
    var $;

    $ = jQuery;

    $.fn.flexNav = function (options) {
        var $nav, $top_nav_items, breakpoint, count, nav_percent, nav_width, resetMenu, resizer, settings, showMenu, toggle_selector, touch_selector;
        settings = $.extend({
            'animationSpeed': 150,
            'buttonSelector': '.header-menu-button',
            'hoverIntent': true,
            'hoverIntentTimeout': 100,
            'hover': true
        }, options);
        $nav = $(this);
        $nav.addClass('with-js');
        $nav.find("li").each(function () {
            if ($(this).has("ul").length) {
                return $(this).addClass("item-with-ul");
            }
        });
        if ($nav.data('breakpoint')) {
            breakpoint = $nav.data('breakpoint');
        }

        // desktop hover show megamenu
        showMenu = function () {
            if ($nav.hasClass('lg-screen') === true && settings.hover === true) {
                return $(this).find('>.dropdown-megamenu').addClass('flexnav-show');
            }
        };
        resetMenu = function () {
            if ($nav.hasClass('lg-screen') === true && $(this).find('>.dropdown-megamenu').hasClass('flexnav-show') === true && settings.hover === true) {
                return $(this).find('>.dropdown-megamenu').removeClass('flexnav-show');
            }
        };

        resizer = function () {
            var selector;

            if ($(window).width() <= breakpoint) {
                $nav.removeClass("lg-screen").addClass("sm-screen");

                selector = settings['buttonSelector'] + ', ' + settings['buttonSelector'] + ' .touch-button';
                $(selector).removeClass('js-active');

                subNav();

                return $('.one-page li a').on('click', function () {
                    return $nav.removeClass('flexnav-show');
                });
            } else if ($(window).width() > breakpoint) {
                $nav.removeClass("sm-screen").addClass("lg-screen");

                $nav.removeClass('flexnav-show').find('.touch-button').removeClass('js-active');
                $('.dropdown-megamenu').removeClass('flexnav-show').css('display', '');
                resetMenu();
                if (settings.hoverIntent === true) {
                    return $('.item-with-ul').hoverIntent({
                        over: showMenu,
                        out: resetMenu,
                        timeout: settings.hoverIntentTimeout
                    });
                } else if (settings.hoverIntent === false) {
                    return $('.item-with-ul').on('mouseenter', showMenu).on('mouseleave', resetMenu);
                }
            }
        };

        subNav = function () {
            if (!$('.touch-button').length) {
                $(settings['buttonSelector']).data('navEl', $nav);
                touch_selector = '.item-with-ul, ' + settings['buttonSelector'];

                if ($(window).width() <= breakpoint) {
                    $(touch_selector).prepend('<div class="touch-button icon-plus"></div>');
                }
                toggle_selector = settings['buttonSelector'] + ', ' + settings['buttonSelector'] + ' .touch-button';
                $(toggle_selector).on('click', function (e) {
                    var $btnParent, $thisNav, bs;
                    $(toggle_selector).toggleClass('js-active');
                    e.preventDefault();
                    e.stopPropagation();
                    bs = settings['buttonSelector'];
                    $btnParent = $(this).is(bs) ? $(this) : $(this).parent(bs);
                    $thisNav = $btnParent.data('navEl');
                    return $thisNav.toggleClass('flexnav-show');
                });
            }
        }

        $('body').on('click', '.touch-button', function (e) {
            var $sub, $touchButton, $parent;
            $sub = $(this).parent('.item-with-ul').find('>.dropdown-megamenu');
            $touchButton = $(this).parent('.item-with-ul').find('>span.touch-button');
            $parent = $(this);
            if ($nav.hasClass('lg-screen') === true) {
                $(this).parent('.item-with-ul').siblings().find('ul.flexnav-show').removeClass('flexnav-show').hide();
            }

            if ($sub.hasClass('flexnav-show') === true) {
                $sub.removeClass('flexnav-show').slideUp(settings.animationSpeed);
                $parent.removeClass('js-active');
                return $touchButton.removeClass('js-active');
            } else if ($sub.hasClass('flexnav-show') === false) {
                $sub.addClass('flexnav-show').slideDown(settings.animationSpeed);
                $parent.addClass('js-active');
                return $touchButton.addClass('js-active');
            }
        });

        resizer();
        return $(window).on('resize', resizer);
    };

}).call(this);
